import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import Icon from '../Icon/Icon';

const HeaderMegaMenuBack = ({ onClick, title }) => <div className="u-hide@desktop">
    <Button
      color="inline-link"
      fullWidth
      className="c-header-nav__link  c-header-nav__link--back"
      onClick={onClick}
    >
      <Icon
        icon="arrow-left"
        className="c-header-nav__icon  c-header-nav__icon--left"
      />
      Back
    </Button>
    {title && (
      <h2 className="c-header-nav__link  c-header-nav__link--top-level">
        {title}
      </h2>
    )}
  </div>

export default HeaderMegaMenuBack;

HeaderMegaMenuBack.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
